import { useContext } from "react";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api, type IDeleteTask } from "@/logic/api";
import { SessionContext } from "@/utility/useSession";
import { useApiWithReject } from "@/utility/utils";

export const useDeleteShiftTask = () => {
    const { current: session } = useContext(SessionContext);
    const queryClient = useQueryClient();
    const deleteTaskApi = useApiWithReject(api.hooks.shift.deleteTask());

    const userUuid = session?.site?.user?.uuid;
    const tenantId = session?.site?.tenant?.id;

    return useMutation<void, Error, IDeleteTask>({
        mutationFn: async (payload) => {
            if (!session?.context) {
                throw new Error("Session context not available");
            }
            await deleteTaskApi.send(session.context, payload);
        },
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: ["shiftTasks", userUuid, tenantId] });
        },
    });
};
